import type { CopyCatalog } from "./copyTypes";

export const SL_COPY: CopyCatalog = {
  "common.loading": "Nalaganje…",
  "common.yes": "Da",
  "common.no": "Ne",
  "common.notProvided": "Ni navedeno",
  "common.notRequired": "Ni zahtevano",
  "common.requested": "Zahtevano",
  "nav.back": "Nazaj",
  "nav.continue": "Nadaljuj",
  "nav.sendRequest": "Pošlji zahtevo",
  "nav.sending": "Pošiljanje…",
  "alert.completeFields": "Pred nadaljevanjem izpolnite označena polja.",
  "fill.filled": "Izpolnjeno",
  "fill.notFound": "Ni najdeno",
  "fill.shipmentToo": "Pošiljka tudi izpolnjena: {detail}",
  "fill.palletMany": "palet",

  "choose.title": "Kako želite zahtevati ponudbo?",
  "choose.manual.title": "Ročni vnos",
  "choose.manual.description": "Vnesite podatke o pošiljki korak za korakom prek vodenega obrazca.",
  "choose.manual.action": "Ročno vnesite podatke",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Prilepite podatke o pošiljki ali naložite dokument, obrazec pa bomo izpolnili namesto vas.",
  "choose.quickfill.action": "Začni hitro izpolnjevanje",

  "steps.route": "Pot in naročilo",
  "steps.shipment": "Pošiljka",
  "steps.services": "Dodatne storitve",
  "steps.contact": "Stik",
  "steps.review": "Pregled",

  "page.route": "Pot in naročilo",
  "page.routeSection": "Pot",
  "page.shipment": "Podatki o pošiljki",
  "page.services": "Dodatne storitve",
  "page.contact": "Kontaktni podatki",
  "page.contactSection": "Vaši kontaktni podatki",
  "page.review": "Pregled",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Analiza vašega dokumenta",

  "route.hintPostcode": "Vnesite poštno številko ali kraj za nakladanje in razkladanje.",
  "route.hintFullAddress": "Vnesite celoten naslov nakladanja in razkladanja.",
  "route.unsupported": "Ta relacija ni podprta. Uporabite obrazec za {loadCountry} in {unloadCountry}.",
  "route.loading": "Nakladanje",
  "route.unloading": "Razkladanje",
  "route.origin": "Izvor",
  "route.destination": "Cilj",
  "route.country": "Država",
  "route.selectCountry": "Izberite državo",
  "route.postcode": "Poštna številka",
  "route.postcodePlaceholder": "npr. 1000",
  "route.city": "Kraj",
  "route.cityPlaceholder": "Vnesite kraj",
  "route.street": "Ime ulice",
  "route.streetPlaceholder": "Vnesite ulico",
  "route.house": "Hišna številka",
  "route.housePlaceholder": "npr. 12",
  "route.pickupDate": "Želeni datum prevzema:",
  "route.unloadDate": "Želeni datum razkladanja:",
  "route.datePlaceholder": "dd. mm. llll",
  "date.clear": "Počisti datum",
  "date.closeCalendar": "Zapri koledar",
  "date.openCalendar": "Odpri koledar",
  "route.specificDateHint":
    "Za blago, ki je na voljo na določen datum. Sicer si prizadevamo za najhitrejšo možnost.",
  "route.orderDetails": "Podatki o naročilu",

  "shipment.goods": "Opis blaga",
  "shipment.goodsPlaceholder": "Kaj želite prevažati?",
  "shipment.weight": "Skupna masa",
  "shipment.qty": "Kol.",
  "shipment.type": "Vrsta",
  "shipment.dims": "Dimenzije / LDM",
  "shipment.stackable": "Skladovno",
  "shipment.addRow": "Dodaj vrstico pošiljke",
  "shipment.totalLines": "Skupaj vrstic: {count}",
  "shipment.selectDims": "Izberite dimenzije",
  "shipment.dimsNa": "Dimenzije niso relevantne",
  "shipment.sizeModeDims": "D × Š × V",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Odstrani vrstico pošiljke {n}",
  "shipment.lineLabel": "{text}, vrstica {n}",
  "shipment.quantity": "Količina",
  "qty.decrease": "Zmanjšaj količino",
  "qty.increase": "Povečaj količino",
  "shipment.lengthCm": "Dolžina (cm)",
  "shipment.widthCm": "Širina (cm)",
  "shipment.heightCm": "Višina (cm)",
  "shipment.dimensions": "Dimenzije",
  "shipment.size": "Velikost",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Polovična paleta",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Po meri",
  "pallet.unspecified": "LDM",

  "services.aria": "Dodatne storitve",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Temperatura",
  "services.pill.tail": "Dvižna rampa",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Časovno okno",
  "services.pill.ref": "Referenca / opombe",
  "services.pill.references": "Reference",
  "services.pill.attachments": "Dodatne priloge",
  "services.adrClass": "Razred ADR",
  "services.selectClass": "Izberite razred",
  "services.unNumber": "Številka ZN",
  "services.unPlaceholder": "npr. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Dvižna rampa pri nakladanju",
  "services.tailUnload": "Dvižna rampa pri razkladanju",
  "services.ftlCopy": "Zahtevan je poln tovornjak.",
  "services.invoiceRef": "Referenca računa",
  "services.reference": "Referenca",
  "services.loadingRef": "Referenca nakladanja",
  "services.unloadingRef": "Referenca razkladanja",
  "services.notes": "Opombe",
  "services.notesPlaceholder": "npr. posebna navodila",
  "services.deadline": "Želeni rok dobave:",
  "services.deliveryHint":
    "Za blago, ki ga je treba dostaviti na določen datum. Sicer si prizadevamo za najhitrejšo možnost.",
  "services.loadingTime": "Čas nakladanja",
  "services.unloadingTime": "Čas razkladanja",
  "services.window": "Okno",
  "services.fixed": "Fiksno",
  "services.at": "ob",
  "services.from": "od",
  "services.to": "do",
  "services.timeTypeAria": "Vrsta: {title}",
  "services.addFiles": "Dodaj datoteke",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP ali PDF. Do {maxFiles} datotek, {maxFileMb} MB vsaka, skupaj {maxTotalMb} MB.",
  "services.adrClass1": "1 Eksplozivne snovi",
  "services.adrClass2": "2 Plini",
  "services.adrClass3": "3 Vnetljive tekočine",
  "services.adrClass4": "4 Vnetljive trdne snovi",
  "services.adrClass5": "5 Oksidativne snovi",
  "services.adrClass6": "6 Strupene / nalezljive snovi",
  "services.adrClass7": "7 Radioaktivne snovi",
  "services.adrClass8": "8 Jedke snovi",
  "services.adrClass9": "9 Razne nevarne snovi",
  "services.summary.adr": "Nevarno blago (ADR)",
  "services.summary.temp": "Nadzorovana temperatura",
  "services.summary.time": "Časovna okna",
  "services.summary.refNotes": "Referenca in opombe",
  "services.summary.tail": "Dvižna rampa",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Dodatne priloge",
  "services.tail.loadUnload": "Nakladanje in razkladanje",
  "services.tail.loadOnly": "Samo nakladanje",
  "services.tail.unloadOnly": "Samo razkladanje",
  "services.time.load": "Nakladanje: {value}",
  "services.time.unload": "Razkladanje: {value}",
  "services.time.deadline": "Rok: {value}",
  "services.time.fixedSuffix": "{time} (fiksno)",
  "services.time.windowRange": "{from} do {until}",
  "services.adr.yes": "Da",
  "services.adr.classUn": "Razred {class}, ZN {un}",
  "services.adr.classOnly": "Razred {class}",
  "services.adr.unOnly": "ZN {un}",
  "services.temp.range": "{min}°C do {max}°C",
  "services.ref.invoice": "Račun: {value}",
  "services.ref.loading": "Nakladanje: {value}",
  "services.ref.unloading": "Razkladanje: {value}",

  "contact.name": "Ime",
  "contact.company": "Podjetje",
  "contact.email": "E-pošta",
  "contact.phone": "Telefon",
  "contact.comment": "Dodatna opomba",
  "contact.privacyBefore":
    "Strinjam se z obdelavo mojih osebnih podatkov v skladu z ",
  "contact.privacyLink": "pravilnikom o zasebnosti",
  "contact.privacyAfter": " podjetja Neele-Vat.",

  "result.thankYou": "Hvala! Vašo zahtevo smo prejeli.",
  "result.teamWillContact":
    "Naša ekipa vas bo kontaktirala v 60 minutah v uradnih urah.",
  "result.teamWillContactEmail":
    "Naša ekipa vas bo kontaktirala v 60 minutah v uradnih urah na {email}.",
  "result.previewMode": "Način predogleda — ta zahteva ni bila resnično poslana.",
  "result.previewFiles": " Opomba: datotek v načinu predogleda ni mogoče poslati.",
  "result.yourReference": "Vaša referenca",
  "result.copy": "Kopiraj",
  "result.copied": "Kopirano",
  "result.nextTitle": "Kaj sledi",
  "result.next1": "Zahteva prejeta.",
  "result.next2": "Zahteva v pregledu.",
  "result.next3": "Odgovor v 60 minutah po e-pošti.",
  "result.logged":
    "Vašo zahtevo smo zabeležili. Če ne slišite od nas, nas kontaktirajte prek podatkov spodaj.",
  "result.newQuote": "Začni novo ponudbo",
  "result.sendFailed": "Vaše zahteve nismo mogli poslati",
  "result.preferDirect": "Želite raje neposreden stik?",
  "result.backToEdit": "Nazaj na urejanje",
  "result.tryAgain": "Poskusi znova",
  "result.hideDetails": "Skrij podrobnosti",
  "result.viewSent": "Poglejte, kaj smo poslali",
  "result.error.rateLimited":
    "V kratkem času ste poslali veliko zahtev. Počakajte trenutek in poskusite znova.",
  "result.error.forbidden":
    "Ta zahteva je bila blokirana. Poskusite znova ali nas kontaktirajte neposredno.",
  "result.error.network":
    "Zahteve trenutno nismo mogli poslati. Preverite povezavo in poskusite znova.",
  "result.error.tooLarge":
    "Zahteva je prevelika za pošiljanje. Uporabite manjše priloge ali krajšo opombo.",
  "result.error.unsupportedType": "Uporabite samo JPEG, PNG, GIF, WebP ali PDF.",
  "result.error.emailUnavailable":
    "Zahteve s prilogami nismo mogli poslati po e-pošti. Poskusite znova ali nas kontaktirajte neposredno.",

  "qf.hint":
    "Prilepite e-pošto ali podatke o pošiljki ali priložite sliko ali PDF. To nadomesti že vnesene podatke.",
  "qf.placeholder":
    "npr. 24 evropalet iz 3011 Rotterdama v 20095 Hamburg, 12.000 kg, prevzem jutri…",
  "qf.ariaPaste": "Podatki o pošiljki za analizo",
  "qf.attach": "Priloži sliko ali PDF",
  "qf.disclaimer":
    "Vse, kar prilepite ali priložite, se uporablja samo za izpolnitev te zahteve. Obdela to naša storitev analize dokumentov in se po izpolnitvi obrazca ne shrani.",
  "qf.fillForm": "Izpolni obrazec",
  "qf.working": "Obdelava…",
  "qf.analyzing": "Analiza vaših podatkov…",
  "qf.noFields": "Ni bilo mogoče prepoznati polj. Dodajte več podrobnosti.",
  "qf.rateLimited": "Poslali ste preveč zahtev. Počakajte trenutek in poskusite znova.",
  "qf.blocked": "Ta zahteva je bila blokirana. Kontaktirajte nas, če je to nepričakovano.",
  "qf.extractUnavailable":
    "Analiza dokumentov trenutno ni na voljo. Namesto tega prilepite podatke o pošiljki.",
  "qf.genericError": "Nekaj je šlo narobe. Preverite omrežje ali poskusite znova.",
  "qf.analyzeTitle": "Analiza vašega dokumenta...",
  "qf.analyzeSub": "To običajno traja nekaj sekund",
  "qf.analyzeStep1": "Branje strukture dokumenta",
  "qf.analyzeStep2": "Izločanje osnovnih podatkov",
  "qf.analyzeStep3": "Prepoznavanje vrstic pošiljke",
  "qf.removeFile": "Odstrani {name}",

  "error.loadCountry": "Izberite državo nakladanja.",
  "error.loadPostal": "Vnesite poštno številko nakladanja.",
  "error.loadCity": "Vnesite kraj nakladanja.",
  "error.loadStreet": "Vnesite ime ulice nakladanja.",
  "error.loadHouseNumber": "Vnesite hišno številko nakladanja.",
  "error.unloadCountry": "Izberite državo razkladanja.",
  "error.unloadPostal": "Vnesite poštno številko razkladanja.",
  "error.unloadCity": "Vnesite kraj razkladanja.",
  "error.unloadStreet": "Vnesite ime ulice razkladanja.",
  "error.unloadHouseNumber": "Vnesite hišno številko razkladanja.",
  "error.pickupDate": "Izberite datum prevzema.",
  "error.unloadDate": "Izberite datum razkladanja.",
  "error.invalidDate": "Vnesite veljaven datum.",
  "error.totalWeight": "Vnesite skupno maso.",
  "error.goods": "Opišite blago.",
  "error.loadCityOrPostal": "Vnesite poštno številko ali kraj nakladanja.",
  "error.unloadCityOrPostal": "Vnesite poštno številko ali kraj razkladanja.",
  "error.loadPostalInvalid": "Vnesite prepoznano poštno številko nakladanja.",
  "error.loadCityInvalid": "Vnesite prepoznan kraj nakladanja.",
  "error.unloadPostalInvalid": "Vnesite prepoznano poštno številko razkladanja.",
  "error.unloadCityInvalid": "Vnesite prepoznan kraj razkladanja.",
  "error.pickupPast": "Datum prevzema ne sme biti v preteklosti.",
  "error.unloadPast": "Datum razkladanja ne sme biti v preteklosti.",
  "error.unloadBeforePickup": "Datum razkladanja ne sme biti pred datumom prevzema.",
  "error.weightRange": "Vnesite maso med 1 in {max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Vnesite 4-mestno številko ZN.",
  "error.invoiceRef": "Vnesite referenco računa.",
  "error.loadingRef": "Vnesite referenco nakladanja.",
  "error.unloadingRef": "Vnesite referenco razkladanja.",
  "error.tempMin": "Vnesite najnižjo temperaturo.",
  "error.tempMax": "Vnesite najvišjo temperaturo.",
  "error.tempOrder": "Maksimum mora biti vsaj enak minimumu.",
  "error.enterNumber": "Vnesite število.",
  "error.deliveryPast": "Rok dobave ne sme biti v preteklosti.",
  "error.deliveryBeforePickup": "Rok dobave ne sme biti pred datumom prevzema.",
  "error.tailSides": "Izberite nakladanje, razkladanje ali oboje.",
  "error.attachOne": "Priložite vsaj eno datoteko.",
  "error.enterTime": "Vnesite uro.",
  "error.enterStartTime": "Vnesite začetni čas.",
  "error.enterEndTime": "Vnesite končni čas.",
  "error.enterMinutes": "Vnesite minute.",
  "error.completeTime": "Vnesite popoln čas.",
  "error.enterEmail": "Vnesite e-poštni naslov.",
  "error.validEmail": "Vnesite veljaven e-poštni naslov.",
  "error.validPhone": "Vnesite veljavno telefonsko številko.",
  "error.personalEmail": "Osebni e-poštni naslovi niso sprejeti.",
  "error.enterName": "Vnesite svoje ime.",
  "error.enterCompany": "Vnesite svoje podjetje.",
  "error.privacy": "Za nadaljevanje se strinjajte.",
  "error.quickFillEmpty":
    "Prilepite podatke o pošiljki ali priložite sliko ali PDF, da izpolnite obrazec.",
  "error.maxFiles": "Priložite lahko do {max} datotek.",
  "error.maxFileMb": "Vsaka datoteka sme imeti največ {max} MB.",
  "error.maxTotalMb": "Priloge smejo imeti skupaj največ {max} MB.",
  "error.filesSkippedType": "Nekatere datoteke so bile preskočene. Uporabite JPEG, PNG, GIF, WebP ali PDF.",
  "error.emptySkipped": "Prazne datoteke so bile preskočene.",
  "error.fileEmpty": "Izbrana datoteka je prazna.",
  "error.filesEmptyOrType": "Nekatere datoteke so bile prazne ali niso JPEG, PNG, GIF, WebP ali PDF.",
  "error.attachType": "Priložite JPEG, PNG, GIF, WebP ali PDF.",
  "error.subjectLong": "Zadeva je predolga.",
  "error.emailTextLong": "Podatki zahteve so predolgi.",
  "error.shortenSubject": "Skratite to vrednost, da zadeva e-pošte ostane znotraj {max} znakov.",
  "error.shortenBody":
    "Skratite podatke o pošiljki ali opombo, da e-pošta ostane znotraj {max} znakov.",

  "announce.choose": "Izberite, kako želite zahtevati ponudbo",
  "announce.quickfill": "Hitro izpolnjevanje: prilepite podatke ali naložite dokument",
  "announce.route": "Korak 1 od 5: pot in naročilo",
  "announce.shipment": "Korak 2 od 5: podatki o pošiljki",
  "announce.services": "Korak 3 od 5: dodatne storitve",
  "announce.contact": "Korak 4 od 5: kontaktni podatki",
  "announce.review": "Korak 5 od 5: preglejte zahtevo",
  "announce.received": "Zahteva prejeta",
  "announce.sendFailed": "Vaše zahteve nismo mogli poslati",
  "announce.sendFailedAttempt": "Vaše zahteve nismo mogli poslati (poskus {n})",
  "announce.completeFields": "Pred nadaljevanjem izpolnite označena polja.",
  "announce.sending": "Pošiljanje vaše zahteve…",
};
